import * as yup from 'yup'
import RolesAccess from '../../enums/roles'

export const usersValidation = yup.object().shape({
    fullName: yup.string().required('Harus diisi'),
    email: yup.string().email('Email harus valid').required('Harus diisi'),
    phoneNumber: yup.string().required('Harus diisi'),
    address: yup.string().required('Harus diisi'),
    password: yup.string()
                    .min(8, 'Minimal 8 karakter')
                    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/, 'Password harus mengandung huruf besar, huruf kecil, dan angka.'),
    confirmPassword: yup.string()
                            .when('password', {
                                    is: (val) => val,
                                    then: (schema) => schema.oneOf([yup.ref('password'), null], 'Passwords harus sama').required('Harus diisi'),
                                    otherwise: (schema) => schema.notRequired(),
                            })
                            ,
    rolesIds: yup.array().min(1, 'Minimal 1 peran').required('Harus diisi'),
    companyIds: yup.array()
                            .when('rolesIds', {
                                    is: (val) => val && val.includes(RolesAccess.PENGELOLA),
                                    then: (schema) => schema.min(1, 'Minimal 1 perusahaan').required('Harus diisi'),
                                    otherwise: (schema) => schema.notRequired(),
                            })
}).required()